import { isRoleType, type Role } from './userConstants';

export const cleanRoles = (roles: string[]) => {
	return roles.filter((role): role is Role => isRoleType(role));
};

export default cleanRoles;
